import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNewsDetail } from "../../Pregrine/NewsAndMedia/useNewsDetail";
import classes from "./NewsDetailPage.module.css";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  XIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import { Helmet } from "react-helmet";
import LoadingIndicator from "../../components/LoadingIndicator";

const NewsDetailPage = (props) => {
  const { id } = useParams();

  const talonProps = useNewsDetail({ id });
  const { NewsDetails, loading } = talonProps;

  useEffect(() => {
    const existingMetaDescription = document.querySelector(
      'meta[name="description"]'
    );
    if (existingMetaDescription) {
      existingMetaDescription.remove();
    }
  }, []);

  if (loading) {
    return <LoadingIndicator />;
  }

  const newsLink = `/news/${NewsDetails.url_key}`;
  const share_url = `${document.location.origin}${newsLink}`;
  const email_body = `Hey, Checkout this amazing Story : ${NewsDetails.name}.`;

  return (
    <>
      <Helmet>
        <meta name="robots" content="index, follow" />
        <title>{NewsDetails.meta_title}</title>
        <meta name="description" content={NewsDetails.meta_description} />
        <link rel="canonical" href={`${document.location.origin}/news/${id}`} />
      </Helmet>
      {/* <BlogSchema NewsDetails={BlogDetails} /> */}
      <div className={classes.blogmainsection}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 mx-auto">
              <div className="row">
                <div className="col-md-12">
                  <h1>{NewsDetails.name}</h1>
                </div>
              </div>
              <div className={`${classes.bannerSection}`}>
                <img src={NewsDetails.banner} alt="Banner" />
              </div>
              <div className={`${classes.rootHeadingBelow}`}>
                <div className={`${classes.shareSection}`}>
                  <FacebookShareButton
                    url={share_url}
                    quote={`Share ${NewsDetails.name}`}
                    description={"facebook"}
                  >
                    <FacebookIcon size={25} round />
                  </FacebookShareButton>

                  <TwitterShareButton
                    title={`Share ${NewsDetails.name}`}
                    url={share_url}
                  >
                    <XIcon size={25} round />
                  </TwitterShareButton>

                  <WhatsappShareButton
                    title={`Share ${NewsDetails.name}`}
                    url={share_url}
                    separator="! "
                    description={"whatsapp"}
                  >
                    <WhatsappIcon size={25} round />
                  </WhatsappShareButton>
                  <LinkedinShareButton
                    title={`Share ${NewsDetails.name}`}
                    url={share_url}
                    separator="! "
                    description={"linkedIn"}
                  >
                    <LinkedinIcon size={25} round />
                  </LinkedinShareButton>

                  <EmailShareButton
                    subject={`Share ${NewsDetails.name}`}
                    url={share_url}
                    body={email_body}
                    separator=" "
                  >
                    <EmailIcon size={25} round />
                  </EmailShareButton>
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: NewsDetails.post_content }}
                className={classes.blogContent}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsDetailPage;
